var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',{staticClass:"font-weight-light text-primary"},[_vm._v("Current jobs")]),_vm._v(" "),_c('CurrentJobs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }